module.exports = __webpack_public_path__ + "images/autoleasegroningen2d9a3223bf3bf4fbabdfbad3ed2953e0.png";